import {removeCookie} from '../../utils/cookies';

export interface NewsletterPopupOptions {
  button: string;
  closeButton: string;
  container: string;
  modal: string;
  modalBg: string;
  popup: string;
  visibleClass: string;
}

type Options = Partial<NewsletterPopupOptions>;

export class NewsletterPopup {
  static defaults: NewsletterPopupOptions = {
    button: '.newsletter__open',
    closeButton: 'mc-closeModal',
    container: '.newsletter',
    modal: '.mc-modal',
    modalBg: '.mc-modal-bg',
    popup: 'PopupSignupForm_0',
    visibleClass: 'is-visible',
  };
  button: HTMLButtonElement;
  container: HTMLElement;
  popup: HTMLElement;
  modal: HTMLDivElement;
  modalBg: HTMLDivElement;
  closeButton: HTMLDivElement;
  closeButtonStatus: string;
  defaultCloseButton: HTMLDivElement;
  options: NewsletterPopupOptions;
  popupOpenHandler: EventListener;
  popupCloseHandler: EventListener;
  observer?: MutationObserver;
  cookies: string;
  interval?: any;

  constructor(container: HTMLElement, options: Options = {}) {
    removeCookie('MCPopupSubscribed');
    removeCookie('MCPopupClosed');

    if (!container) {
      return;
    }

    this.options = {
      ...NewsletterPopup.defaults,
      ...options,
    };

    this.container = container as HTMLElement;
    this.button = document.querySelector(
      this.options.button,
    ) as HTMLButtonElement;
    this.cookies = document.cookie;

    this.onLoad = this.onLoad.bind(this);
    this.lookForPopup = this.lookForPopup.bind(this);

    this.onLoad();
  }

  bind() {
    this.popupOpenHandler = this.handlePopupOpen.bind(this);
    this.popupCloseHandler = this.handlePopupClose.bind(this);
    this.checkHidden = this.checkHidden.bind(this);
    this.button.addEventListener('click', this.popupOpenHandler);
    this.closeButton.addEventListener('click', this.popupCloseHandler);
    this.modalBg.addEventListener('click', this.popupCloseHandler);
  }

  onLoad() {
    window.addEventListener('load', () => {
      const popup = document.querySelector(this.options.popup);
      if (popup) {
        this.onReady(popup);
      } else {
        this.observer = new MutationObserver(this.lookForPopup);
        this.observer.observe(document.body, {childList: true});
      }
    });
  }

  onReady(popup: Element) {
    this.popup = popup as HTMLElement;
    this.modal = this.popup.querySelector(this.options.modal) as HTMLDivElement;
    this.modalBg = this.popup.querySelector(
      this.options.modalBg,
    ) as HTMLDivElement;
    this.handleCloseButton();
    this.bind();
    this.button.disabled = false;
  }

  lookForPopup(mutations: MutationRecord[]) {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        const added = mutation.addedNodes[0] as HTMLDivElement;
        if (added && added.id === this.options.popup) {
          const popup = document.getElementById(this.options.popup);
          if (popup) {
            this.onReady(popup);
            if (this.observer) {
              this.observer.disconnect();
            }
          }
        }
      }
    }
  }

  handleCloseButton() {
    this.defaultCloseButton = this.popup.getElementsByClassName(
      this.options.closeButton,
    )[0] as HTMLDivElement;
    const newCloseButton = document.createElement('DIV');
    this.closeButton = newCloseButton as HTMLDivElement;
    this.closeButton.classList.add(this.options.closeButton);
    this.modal.appendChild(this.closeButton);
  }

  handlePopupOpen() {
    this.popup.classList.add(this.options.visibleClass);
    this.addHiddenListener();
  }

  handlePopupClose() {
    this.popup.classList.remove(this.options.visibleClass);
  }

  addHiddenListener() {
    this.interval = setInterval(this.checkHidden, 1000);
  }

  checkHidden() {
    this.closeButtonStatus = this.defaultCloseButton.style.display || '';
    if (this.closeButtonStatus === 'none') {
      this.changeButtonMessage();
      clearInterval(this.interval);
    }
  }

  changeButtonMessage() {
    this.button.textContent = "you're signed up!";
    this.button.disabled = true;
  }

  destroy() {
    this.button.removeEventListener('click', this.popupOpenHandler);
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
